export default "__VITE_ASSET__DAsw0zt2__"